export class TagService {
  private colors = ['#ff00ff', '#ff6666', '#009933', '#3366ff', '#996633', '#669999', '#6600cc', '#ff9900', '#b3b300'];
  public tagColors(tags: any[]) {
    const colorMap: any = {};
    tags.forEach((tag, index) => (colorMap[tag.id] = this.colors[index % this.colors.length]));
    return colorMap;
  }
}

export default new TagService();
